import { useTheme } from '@mui/material';

import { Iconify } from 'src/components/iconify/iconify';

function CheckIcon() {
  const theme = useTheme();

  return <Iconify icon="eva:checkmark-fill" color={theme.palette.success.main} width={16} />;
}

export default CheckIcon;
